import { __awaiter, __generator } from "tslib";
import { oc } from "ts-optchain";
var Ow30DayAccount = (function () {
    function Ow30DayAccount(_authTokenEndpoint) {
        this._authTokenEndpoint = _authTokenEndpoint;
    }
    Ow30DayAccount.prototype.TokenizeOw30DayAccount = function (popup) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        var onMessage = function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var response, tokenReceipt, _a, custBP, orgBP, signature;
                            return __generator(this, function (_b) {
                                response = event.data;
                                if (typeof response.type === "undefined")
                                    return [2];
                                if (window.location.hostname === "localhost") {
                                    console.log("MESSAGE FROM OW OAUTH");
                                    console.log(event.data);
                                }
                                window.removeEventListener("message", onMessage);
                                popup.close();
                                if (response.type !== "LOGIN_SUCCESS") {
                                    reject(response.payload.message);
                                    return [2];
                                }
                                if (!oc(response).payload.profile.hasThirtyDayAccount(false)) {
                                    reject("DECLINED");
                                    return [2];
                                }
                                tokenReceipt = this._authTokenEndpoint.replace("auth-token", "token-receipt");
                                _a = oc(response).payload.profile, custBP = _a.custBP, orgBP = _a.orgBP, signature = _a.signature;
                                resolve({
                                    redirectUrl: tokenReceipt + "/ow30dayaccount/ow30dayaccount",
                                    resultToken: orgBP("") + "|" + custBP("") + "|" + signature(""),
                                });
                                return [2];
                            });
                        }); };
                        window.addEventListener("message", onMessage);
                    })];
            });
        });
    };
    Ow30DayAccount.prototype.TokenizeCreditCard = function (_authResponse, _creditCard, _customerRef) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("Not Implemented");
            });
        });
    };
    Ow30DayAccount.prototype.TokenizeBankAccount = function (_authResponse, _bankAccount, _customerRef) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("Not Implemented");
            });
        });
    };
    return Ow30DayAccount;
}());
export { Ow30DayAccount };
//# sourceMappingURL=Ow30DayAccount.js.map